import { SET_LOGIN, SET_ROLE, SET_ACTIVE_ROUTE, SET_ACCESS_DETAILS } from "../../Actions/Types";

const login = {
    loggedIn: JSON.parse(localStorage.getItem("login")),
    role: 'L2',
    accessToken: '',
    activeRoute: '',
    accessDetails: [],
};
const LoginReducer = (state = login, action) => {
    switch (action.type) {
        case SET_LOGIN:
            return {
                ...state,
                accessToken: action.payload
            };
        case SET_ROLE:
            return {
                ...state,
                role: action.payload
            };
        case SET_ACTIVE_ROUTE:
            return {
                ...state,
                activeRoute: action.payload,
            };
        case SET_ACCESS_DETAILS:
            return {
                ...state,
                accessDetails: action.payload,
            };
        default: return state;
    }
};
export default LoginReducer;